import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ReactiveFormsModule, Validators } from "@angular/forms";
import {
  EFormFieldTypes,
  IFormFields,
} from "@shared/form/basic/basic-form.interface";
import { RegionService } from "../../../services/region.service";
import { BasicEditForm } from "@shared/form/basic/basic-edit.form";
import { CabButtonComponent } from "@shared/form/components/cab-button/cab-button.component";
import { CabInputComponent } from "@shared/form/components/cab-input/cab-input.component";
import { CabTabComponent } from "@shared/cab-tab/cab-tab.component";
import { CabLoadingComponent } from "@shared/cab-loading/cab-loading.component";

@Component({
  selector: "app-edit-region-form",
  templateUrl: "../region-form.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CabTabComponent,
    CabInputComponent,
    CabButtonComponent,
    CabLoadingComponent,
  ],
})
export class EditRegionFormComponent extends BasicEditForm {
  override _defaultService = inject(RegionService);
  override formFields: IFormFields = {
    id: this.createFormField(null),
    cadastralCode: this.createFormField(null),
    soato: this.createFormField(null),
    name: this.createFormField(
      null,
      [Validators.required, Validators.minLength(3)],
      EFormFieldTypes.TRANSLATE
    ),
  };
}
